/**
 * Join class names, dropping the empty ones.
 *
 * Every primitive in this folder is a base string plus a caller's `className`,
 * and either can be absent. Without this each of them grows its own filter and
 * they drift: one emits a trailing space, another a double one, and a snapshot
 * diff picks up the difference for no reason.
 */
export function cx(...parts: readonly (string | false | null | undefined)[]): string {
  return parts.filter((part): part is string => typeof part === 'string' && part !== '').join(' ');
}
